import { Component } from 'react'
import { getApiData } from 'helpers/api'

class BaseWidget extends Component {
  constructor(props,dataSource) {
    super(props);
    this.state = {
      searchLoc: window.location.search
    };
    this.dataSource = dataSource;
  }

  componentDidMount() {
    getApiData(this.dataSource,window.location.search);
  }

  componentDidUpdate(prevProps) {
    if (window.location.search !== this.state.searchLoc) {
      getApiData(this.dataSource,window.location.search);
      this.setState( {searchLoc: window.location.search } );
    }
  }

  render() {
    return null
  }
}
        
export default BaseWidget;

